export const RunHistoryCardTestIds = {
  PREV_PAGE_BUTTON: 'run-history.prev-page-button',
  NEXT_PAGE_BUTTON: 'run-history.next-page-button',
};
